export default {
    groupData: {},
    operations: [],
    otherOperations: [],
    departments: [],
    modalContext: {},
    lastGroup: {},
    source: {},
    defaultCurrency: {},
    errors: [],
    method: '',
    returnUrl: '',
    addContractorsUrl: '',
    useExchangeRates: false,
    modalCheckboxes: {},
    stateToCommit: {
        operations: [],
        otherOperations: []
    }
}
